import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useLockscreen } from "../../context/LockscreenContext";
import logoLight from "../../assets/images/brand/logo-dark.png";
import logoDark from "../../assets/images/brand/logo-white.png";
import "./LockscreenModal.scss";

const LockscreenModal = () => {
  const { locked, unlock, close } = useLockscreen();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [logo, setLogo] = useState(logoLight);

   useEffect(() => {
    const updateLogo = () => {
      const isDark = document.body.classList.contains("dark-mode");
      setLogo(isDark ? logoDark : logoLight);
    };

    updateLogo(); // initial

    const observer = new MutationObserver(updateLogo);
    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

    return () => observer.disconnect();
  }, []);

  const handleUnlock = () => {
    if (unlock(password)) {
      setPassword("");
      setError("");
      close(); // Cierra el modal si la contraseña es correcta
    } else {
      setError("❌ Contraseña incorrecta. Intenta de nuevo.");
    }
  };

  return (
    <Modal
      show={locked}
      backdrop="static"
      keyboard={false}
      centered
      contentClassName="lockscreen-modal"
    >
      <div className="lockscreen-container novian-form">
        <img src={logo} alt="NovianCore" className="lockscreen-logo" />
        <h5 className="lockscreen-title">Pantalla bloqueada</h5>
        <p className="lockscreen-subtitle">Ingresa tu contraseña para continuar.</p>

        <input
          type="password"
          className="form-control lockscreen-input mb-2"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoFocus
        />

        {error && (
          <div className="text-danger text-center small mb-3">{error}</div>
        )}

        <button className="btn btn-primary w-100" onClick={handleUnlock}>
          Desbloquear
        </button>
      </div>
    </Modal>
  );
};

export default LockscreenModal;